import { useT } from '@dia/i18n';
import { Button } from '@dia/ui';
import { RequireAuth } from './lib/identity';
import { NavRow, Page } from './lib/ui';

/**
 * Everything that is not one of the four everyday tabs, as a short list.
 *
 * Who sees what is decided by role (CLAUDE.md Section 4), never by a per
 * person list: everybody on the staff gets the same rows, and the manager and
 * owner hub is one more row for a manager or an owner. The database enforces
 * the same rule (migration 023), so a row is a way in, not a permission.
 */
export function Mas() {
  return (
    <RequireAuth>
      {(who) => <MasBody role={who.role} signOut={who.signOut} />}
    </RequireAuth>
  );
}

function MasBody({ role, signOut }: { role: 'crew' | 'manager' | 'owner'; signOut: () => void }) {
  const { t } = useT();
  return (
    <Page title={t('ops.more.title')}>
      <div className="mt-2 flex flex-col gap-3">
        <NavRow to="/energia" icon="bolt" title={t('ops.power.title')} hint={t('ops.power.nav_hint')} />
        <NavRow to="/mensajes" icon="chat" title={t('ops.nav.messages')} hint={t('ops.more.messages_hint')} />
        <NavRow to="/traductor" icon="translate" title={t('ops.nav.translator')} hint={t('ops.more.translator_hint')} />
        <NavRow to="/habitaciones" icon="bed" title={t('ops.nav.rooms')} hint={t('ops.more.rooms_hint')} />
        {role !== 'crew' && (
          <NavRow to="/jefe" icon="users" title={t('ops.nav.boss')} hint={t('ops.more.boss_hint')} />
        )}
        <div className="mt-4">
          <Button variant="secondary" block onClick={signOut}>
            {t('action.sign_out')}
          </Button>
        </div>
      </div>
    </Page>
  );
}
